<template>
  <div class="medication-status">
    <medication-adherence :adherenceLevel="1" />
    <v-row class="border ma-0 pa-2 my-3">
      <v-col cols="10" class="pa-5 mb-4">
        <v-row>
          <v-col>
            <h3 class="pb-5">
              {{ $ucfirst($t("medication.medicationAdherenceBarriers")) }}
            </h3>
          </v-col>
        </v-row>
        <medication-adherence-barriers
          :green="barriersGreen"
          :orange="barriersOrange"
          :red="barriersRed"
          :noData="true"
        />
      </v-col>
      <v-col cols="2" align="center">
        <p style="font-size: 0.9em" v-if="IMABDate">{{$ucfirst($t('pa.reportedOn'))}} {{IMABDate}}</p>
        <imab-score
          :score="IMABScore"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MedicationAdherence from "../../../components/Parts/MedicationAdherence";
import MedicationAdherenceBarriers from "../../../components/Parts/MedicationAdherenceBarriers";
import ImabScore from "../../../components/Parts/ImabScore";
import gql from 'graphql-tag';
import { mapGetters } from 'vuex';

/**
 * Component PatientOverviewMedicationStatus.vue
 *
 * @module PatientOverviewMedicationStatus
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.6] app/src/APP_DASHBOARD/templates/views/Patient/Medication/PatientOverviewMedicationStatus.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PatientOverviewMedicationStatus",
  components: {
    MedicationAdherence,
    MedicationAdherenceBarriers,
    ImabScore,
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
  },
  data: function(){
    return {
      barriersGreen: [],
      barriersOrange: [],
      barriersRed: [],
      IMABScore: 0,
      IMABDate: null,
    }
  },
  watch: {
    patientId: function () {
      this.getMedicationAdherenceBarriers();
    },
  },
  mounted: function(){
    this.getMedicationAdherenceBarriers();
  },
  methods: {
    getMedicationAdherenceBarriers: function() {
      const questionnaires = ['IMAB', 'GAD-7', 'PHQ-9'];

      // Clear possible previous values.
      this.barriersGreen = [];
      this.barriersOrange = [];
      this.barriersRed = [];

      questionnaires.forEach((questionnaire) => {
        this.$app.apolloMobileClient
          .query({
            query: gql`
              query getQuestionnaireForm(
                $patientId: String!
                $questionnaire: String!
              ) {
              myQuestionnaireForms(
                functions: { function: patientId, parameters: [$patientId] }
                conditions : {gate : and, inputs : [
                  {field : key, value : $questionnaire}
                ]},
                orders : {field : version, direction : desc}
                limit : 1
              ){
                questionnaire{
                  key
                }

                id
                completed
                score
                entryDate
                entries{
                  id
                  question{
                    key
                    text
                    sequence
                  }
                  givenAnswers{
                    id
                    key
                    score
                    text
                  }
                }

              }
            }
            `,
            variables: {
              patientId: this.patientId,
              questionnaire: questionnaire
            },
          })
          .then((result) => {
            // console.log('QUESTIONNAIRE:' + questionnaire, result);
            let barriers = this.$app.patientManager.calculateBarriers(questionnaire, result);
            // console.log(barriers);
            barriers.barriersGreen.forEach(barrier => {
              this.barriersGreen.push(this.$t(barrier, {catalog: 'app_dashboard'}));
            });

            barriers.barriersOrange.forEach(barrier => {
              this.barriersOrange.push(this.$t(barrier, {catalog: 'app_dashboard'}));
            });

            barriers.barriersRed.forEach(barrier => {
              this.barriersRed.push(this.$t(barrier, {catalog: 'app_dashboard'}));
            });

            if(barriers.IMABDate) {
              this.IMABDate = barriers.IMABDate;
            }

            if(barriers.IMABScore) {
              this.IMABScore = barriers.IMABScore;
            }
          });
      })
    },
  },
};
</script>
<style lang="scss">
</style>
